<div class="options-menu-item--wrapper" (click)="itemClick()">
  <ark-icon color="dark" [icon]="item.icon" size="small"></ark-icon>
  <div class="label">{{ item.label | translate }}</div>
</div>
